export default {
  boothConsultation: '展位咨询',
  exhibitionTicketConsultation: '展会门票咨询',
  boothSale: '展位销售',
  telephone: '直线',
  mobilePhone: '手机',
  wechat: '专属微信',
  onlineContact: '在线问',
  workTime: '工作时间'
}
